import { Box, Button, Checkbox, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../Layout/MainDashboardLayout";
import Unauthorized from "../Unauthorized/Unauthorized";
import EastIcon from "@mui/icons-material/East";
import { useNavigate, useParams } from "react-router-dom";
import { get, put } from "../../utils/api";

const ReviewPage = ({ component, module, url, url1, disable }) => {
  const { id } = useParams();
  const [checked, setChecked] = useState(false);
  const navigate = useNavigate();
  console.log(url, url1, "url");
  const item = url?.includes("gri") ? "griReview" : "brsrReview";
  const updateUrl = url?.includes("brsr")
    ? "/brsr/updateBRSR"
    : "/gri/grilist/update";

    console.log(url,url1,"url1")

  const navigateUrl=url?.includes("gri") ? `/gri/general-disclosure/2-1/${id}` : `/brsr/instructions/${id}`;

  const handleSubmit = async () => {
    try {
      const res1 = await put(`${updateUrl}?id=${id}`, { status: "Reviewed" });
      console.log(res1, "url");
      navigate("/dashboard");
    } catch (err) {
      console.log(err);
    }
  };

  // const fetchData = async () => {
  //   let data = await get(`/brsr/get/brsr?id=${id}`);
  // };

  // useEffect(() => {
  //   fetchData();
  // }, []);

  return (
    <MainDashboardLayout sidebar={component}>
      <Unauthorized requiredModule={module}>
        <Box sx={{ backgroundColor: "E9EDF1" }}>
          {" "}
          <Typography
            sx={{
              fontFamily: "inter",
              fontWeight: 600,
              fontSize: "20px",
              lineHeight: "24px",
              textTransform: "uppercase",
              color: "#4D4D4D",
              my: "2rem",
            }}
          >
            Section : Review And Submit
          </Typography>
          <Typography
            sx={{
              fontFamily: "inter",
              fontWeight: 600,
              fontSize: "20px",
              lineHeight: "24px",
              textTransform: "uppercase",
            }}
          >
            Great Job! you've reached the end.
          </Typography>
          <Typography
            sx={{
              fontFamily: "inter",
              fontWeight: 500,
              fontSize: "16px",
              lineHeight: "24px",
              mt: "2rem",
            }}
          >
            Take a moment to review your entries. Accuracy
            matters, and we're here to help you get it right.
          </Typography>
          <Typography
            sx={{
              fontFamily: "inter",
              fontWeight: 400,
              fontSize: "16px",
              lineHeight: "24px",
              mt: "1rem",
            }}
          >
            Reviewing your entries will
            help prevent errors and ensure compliance with the requirements.
          </Typography>
          {/* <Typography
            sx={{
              fontFamily: "inter",
              fontWeight: 600,
              fontSize: "20px",
              lineHeight: "24px",
              textTransform: "uppercase",
              mt: "3rem",
            }}
          >
            Review & submit answers{" "}
          </Typography>
          <Box
            display="flex"
            // alignItems="center"
            gap={1}
            sx={{ ml: "-0.7rem", mt: "1rem" }} // Applies white to text
          >
            <Box>
              <Checkbox
                checked={checked}
                onChange={(e) => setChecked(e.target.checked)}
                sx={{
                  "&.Mui-checked": {
                    color: "#488257",
                  },
                }}
              />
            </Box>
            <Typography
              sx={{
                fontFamily: "inter",
                fontWeight: 600,
                fontSize: "16px",
                lineHeight: "24px",
                mt: "0.5rem",
              }}
            >
              I have reviewed my entries and confirm they are accurate.
            </Typography>
          </Box>
          <Typography
            sx={{
              fontFamily: "inter",
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "24px",
              ml: "2.3rem",
            }}
          >
            Checking this box confirms that you have reviewed your data. Once
            checked, the Submit button will be activated.
          </Typography>
          {checked ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: "4rem",
                gap: 2,
              }}
            >
              <Button
                onClick={() => {
                  navigate(url);
                }}
                sx={{
                  backgroundColor: "#1C486B",
                  textTransform: "none",
                  background: "#fff",
                  color: "#000000",
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontStyle: "inter",
                  borderRadius: "5px",
                  border: "1px solid #1C486B",
                  px: "1rem",
                  width: "10rem",
                  alignItems: "center",
                  "&:hover": {
                    backgroundColor: "#f5f5f5", // keep white background on hover
                  },
                }}
              >
                Review Again
              </Button>
              <Button
                onClick={handleSubmit}
                disabled={disable}
                sx={{
                  backgroundColor: "#1C486B",
                  textTransform: "none",
                  background: "#1C486B",
                  color: "white",
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontStyle: "inter",
                  borderRadius: "5px",
                  border: "none",
                  px: "1rem",
                  width: "10rem",
                  alignItems: "center",
                  "&:hover": {
                    backgroundColor: "#1C486B", // keep white background on hover
                  },
                }}
              >
                <span>
                  Submit <EastIcon sx={{ ml: 2 }} />
                </span>
              </Button>
            </Box>
          ) :  */}
          {/* ( */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: "4rem",
                gap: 2,
              }}
            >
              <Button
                onClick={() => navigate(url1)}
                sx={{
                  backgroundColor: "#1C486B",
                  textTransform: "none",
                  background: "#fff",
                  color: "#000000",
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontStyle: "inter",
                  borderRadius: "5px",
                  border: "1px solid #1C486B",
                  px: "1rem",
                  width: "10rem",
                  alignItems: "center",
                  "&:hover": {
                    backgroundColor: "#f5f5f5", // keep white background on hover
                  },
                }}
              >
                Review Later
              </Button>
              <Button
                onClick={() => {
                  localStorage.setItem(item, JSON.stringify(item==="brsrReview" ? true:false));
                  navigate(navigateUrl);
                }}
                sx={{
                  backgroundColor: "#1C486B",
                  textTransform: "none",
                  background: "#1C486B",
                  color: "white",
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontStyle: "inter",
                  borderRadius: "5px",
                  border: "none",
                  px: "1rem",
                  width: "11rem",
                  alignItems: "center",
                  "&:hover": {
                    backgroundColor: "#1C486B", // keep white background on hover
                  },
                }}
              >
                <span>
                  Review Now <EastIcon sx={{ ml: 2 }} />
                </span>
              </Button>
            </Box>
          {/* )} */}
        </Box>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default ReviewPage;
